import axios from 'axios'
import {
  requestInterceptor,
  responseInterceptor,
} from 'shared/infrastructure/interceptors/interceptors'

const b2bApiClient = (
  http,
  headers = {
    'Content-Type': 'application/json',
  },
) => {
  const client = http.create({
    baseURL: `${process.env.API_GATEWAY}/b2b`,
    headers: { ...headers },
  })
  client.interceptors.request.use(request => requestInterceptor(request))
  client.interceptors.response.use(response => responseInterceptor(response))
  return client
}

const b2bApi = b2bApiClient(axios)

export { b2bApi }
